import React, { useContext, useState } from 'react'
import Radio from '@Components/Fields/Radio'
import Button from '@Components/Buttons/Button'
import { createTsvRequest } from '@App/api/routes/rightsholder/statements'
import { StoresContext } from '@App/contexts'

interface RoyaltyStatementDownloadFormProps {
    setIsFormSubmitted: (isFormSubmitted: boolean) => void
    downloadData?: string[]
}

const RoyaltyStatementDownloadForm = (props: RoyaltyStatementDownloadFormProps) => {
    const [downloadFormat, setDownloadFormat] = useState('SUMMARY')
    const [downloadType, setDownloadType] = useState('CONSOLIDATED')
    const { preloaderStore, rightsholderStore } = useContext(StoresContext)

    const submitTsvRequest = () => {
        preloaderStore.openTransparentPreloader(true)
        createTsvRequest(rightsholderStore.currentRightsholderId, {
            format: downloadFormat,
            fileType: downloadType,
            data: props.downloadData,
        }).then()

        props.setIsFormSubmitted(true)
        preloaderStore.openTransparentPreloader(false)
    }

    return (
        <>
            <Radio
                options={[
                    {
                        id: 1,
                        value: 'SUMMARY',
                        label: 'Work Summary',
                        description: 'This format provides royalty data summarized at the musical work level.',
                    },
                    {
                        id: 2,
                        value: 'DETAILS',
                        label: 'Royalty Detail',
                        description:
                            'This format provides royalty data ' +
                            'corresponding with the individual sound recordings contained in' +
                            ' DSP usage reports.',
                    },
                ]}
                field={{ name: 'Format' }}
                title="Format:"
                defaultCheckedId={1}
                onChange={(option) => setDownloadFormat(option.value)}
            />
            <Radio
                options={[
                    {
                        id: 3,
                        value: 'CONSOLIDATED',
                        label: 'Consolidated',
                        description: 'This file type will combine all selected data into one file.',
                    },
                    {
                        id: 4,
                        value: 'INDIVIDUAL',
                        label: 'Individual',
                        description: 'This file type will preserve separate files for all selected data.',
                    },
                ]}
                field={{ name: 'File Type' }}
                title="File Type:"
                defaultCheckedId={3}
                onChange={(option) => setDownloadType(option.value)}
            />
            <div className="download-button">
                <Button mainColor type="primary" onClick={() => submitTsvRequest()}>
                    Download
                </Button>
            </div>
        </>
    )
}

export default RoyaltyStatementDownloadForm
